// src/theme/theme.js
import { BorderColor } from "@mui/icons-material";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1266,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: "rgba(36,93,173,1)", 
    },
    secondary: {
      main: "#5e5e5e",
    },
    error: {
      main: "#d32f2f",
    },
    background: {
      default: "#f4f4f4",
    },
    text: {
      primary: "#000000",
      secondary: "#555555",
    },
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
    h1: {
      fontSize: "2rem",
      fontWeight: 600,
      color:'#0D0D0D',
      [createTheme().breakpoints.down("sm")]: {
        fontSize: "1.5rem",
      },
    },
    h2: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h2Mobile: {
      fontSize: "1.85rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1.125rem",
      lineHeight: 1.5,
      fontWeight:500
    },
    button: {
      textTransform: "none", // Disable uppercase for buttons
    },
    p: {
      color: "#ACACAC",
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4, // Custom border radius for buttons
          boxShadow:"none"
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          // marginBottom: "24px", // Add spacing between fields
          // borderColor:'#000',
          // paddingTop:8
        },
      },
    },
    MuiOutlinedInput:{
      styleOverrides:{
        root:{
          // border: '1px solid  #0D0D0D',
          // borderRadius:8
        }
      }
    },
    MuiInputLabel:{
      styleOverrides:{
        root:{
          fontSize:'1.25rem',
          color:'#0D0D0D',
          fontWeight:400
        }
      }
    },
    MuiFormHelperText:{
      styleOverrides:{
        root:{
          marginLeft:0
        }
      }
    },
    MuiDataGrid:{
      styleOverrides:{
        root:{
          border: "1px solid #fff",
        },
        columnHeaders: {
          backgroundColor: "#fff",
          color: "#7A7A7A",
          fontSize: "1rem",
          fontWeight:400
        },
        row: {
          "&.Mui-selected": {
            backgroundColor: "#d6f5f4",
            "&:hover": {
              backgroundColor: "#70befd6b",
            },
          },
        },
        cell:{
          "&.Mui-selected":{
            borderColor:"#ffffff"
          }
        }
      }
    },
    MuiPaper:{
      styleOverrides:{
        root:{
          boxShadow:"none"
        }
      }
    }
  },
});

export default theme;
